module.exports = __webpack_public_path__ + "media/images/f-logo-4d76fdc3ff5ac44778e79bb9cdaaab7d.png";